import React from "react";
import {Badge, Button, Card, CardBody, CardHeader, Container} from "reactstrap";
import {inject, observer} from "mobx-react";
import {Link} from "react-router-dom";
import moment from "moment";
import TableGeneric from "../../../components/Akitatek/Headers/TableGeneric";
import Pagination from "../../../components/Akitatek/Pagination";
import getRoutes from "../../../components/Akitatek/getRoutes";
import {dureeLisible, numeroLisible} from "../../../util/telephonieFormat";

const COULEURS = {sonne: "success", en_cours: "info", repondu: "secondary", manque: "danger"};

/**
 * Journal des appels reçus sur la ligne du magasin (téléphonie OVH), avec les appels manqués à rappeler.
 */
const Appels = (inject("rootStore")(observer(class Appels extends React.Component {

    get store() {
        return this.props.rootStore.telephonieStore;
    }

    constructor(props, context) {
        super(props, context);
        this.props.rootStore.savedDatasStore.setHeader("Appels", "Appels reçus sur la ligne du magasin", "default.jpg");
    }

    componentDidMount() {
        this.store.currentPage = 1;
        this.store.getAppels();
    }

    filtrer(statut, aTraiter) {
        this.store.currentPage = 1;
        this.store.statut = statut;
        this.store.aTraiter = aTraiter;
        this.store.getAppels();
    }

    parentCallback = (page) => {
        this.store.currentPage = page;
        this.store.getAppels();
    };

    row(appel) {
        const store = this.store;

        return (
            <tr key={appel.id}>
                <td>{appel.sonne_le ? moment(appel.sonne_le).format("DD/MM/YYYY HH:mm") : "—"}</td>
                <td>{numeroLisible(appel.numero)}</td>
                <td>
                    {appel.client
                        ? <Link to={getRoutes("Modifier Client", appel.client.id)}>{appel.client.nom}</Link>
                        : <span className="text-muted">Inconnu</span>}
                </td>
                <td className="text-center">
                    <Badge pill color={COULEURS[appel.statut] ?? "secondary"}>{store.statuts[appel.statut] ?? appel.statut}</Badge>
                    {appel.source === "historique" && <div><small className="text-muted">rattrapé depuis OVH</small></div>}
                </td>
                <td className="text-center">{dureeLisible(appel.duree)}</td>
                <td className="text-center" style={{whiteSpace: "nowrap"}}>
                    {store.click2call && appel.numero && appel.numero.startsWith("+") &&
                    <Button size="sm" color="success" className="mr-1" onClick={() => store.appeler(appel.numero)}>
                        <i className="fa fa-phone" aria-hidden="true"/> Rappeler
                    </Button>}
                    {appel.statut === "manque" && !appel.traite_le &&
                    <Button size="sm" color="secondary" onClick={() => store.traiter(appel.id)}>Traité</Button>}
                    {appel.traite_le && <small className="text-muted">traité le {moment(appel.traite_le).format("DD/MM HH:mm")}</small>}
                </td>
            </tr>
        );
    }

    render() {
        const store = this.store;
        const filtre = (libelle, statut, aTraiter, compteur) => (
            <Button className="mr-2" color={store.statut === statut && store.aTraiter === aTraiter ? "primary" : "secondary"}
                    onClick={() => this.filtrer(statut, aTraiter)}>
                {libelle}{compteur !== undefined && <> <Badge color="light">{compteur}</Badge></>}
            </Button>
        );

        return (
            <Container className="mt-2" fluid>
                <Card className="shadow">
                    <CardHeader style={{display: "flex", justifyContent: "space-between", flexWrap: "wrap"}}>
                        <h4 className="mb-0">Appels</h4>
                        <div style={{display: "flex", flexWrap: "wrap"}}>
                            {filtre("Manqués à traiter", "manque", true, store.manquesATraiter)}
                            {filtre("Tous les manqués", "manque", false)}
                            {filtre("Tous les appels", "", false)}
                        </div>
                    </CardHeader>
                    <CardBody>
                        {store.appels.length === 0
                            ? <p className="text-muted">Aucun appel.</p>
                            : <TableGeneric key="appels" titles={["Date", "Numéro", "Client", "Statut", "Durée", ""]}>
                                {store.appels.map(appel => this.row(appel))}
                            </TableGeneric>}
                        <Pagination currentPage={store.currentPage} lastPage={store.lastPage} parentCallback={this.parentCallback}/>
                    </CardBody>
                </Card>
            </Container>
        );
    }
})));

export default Appels;
